import { TeamRole } from '@showbie-socrative/socrative-utils';
import { AxiosResponse } from 'axios';

import localAxios from '../localAxios';
import { updateTeamSettingsUrl } from './urls';

export interface UpdateTeamSettingsParams {
  teamId: string;
  canInvite?: Array<TeamRole>;
  canViewEmail?: Array<TeamRole>;
}

export interface ChangeTeamSettingsRequest {
  can_invite?: Array<TeamRole> | null;
  can_view_email?: Array<TeamRole> | null;
}

interface ChangeTeamSettingsResponse {
  canInvite: Array<TeamRole>;
  canViewEmail: Array<TeamRole>;
}

export async function changeTeamSettings({
  teamId,
  canInvite,
  canViewEmail: canSeeEmail,
}: UpdateTeamSettingsParams): Promise<ChangeTeamSettingsResponse> {
  const url = updateTeamSettingsUrl({ teamId });
  const { data } = await localAxios.put<
    ChangeTeamSettingsRequest,
    AxiosResponse<ChangeTeamSettingsResponse>
  >(url.href, {
    can_invite: canInvite,
    can_view_email: canSeeEmail,
  });

  return data;
}
